import { Text } from "tamagui";
import type BaseModuleModel from "../modules/core/BaseModuleModel";

export const ModuleIcon: React.FC<{
  // biome-ignore lint/suspicious/noExplicitAny: Because
  module: BaseModuleModel<any, any>;
  size?: number;
}> = ({ module, size = 24 }) => {
  if (module.data.emoji) {
    return (
      <Text lineHeight={size} fontSize={size}>
        {module.data.emoji}
      </Text>
    );
  }

  return module.renderIcon(size);
};
